import { render } from "./ResidentCharting.vue?vue&type=template&id=8c499124"
import script from "./ResidentCharting.vue?vue&type=script&lang=js"
export * from "./ResidentCharting.vue?vue&type=script&lang=js"

import "./ResidentCharting.vue?vue&type=style&index=0&id=8c499124&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__